export const PRIORITIES = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PRIORITIZED',
    value: 1,
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.NOT_PRIORITIZED',
    value: 0,
  },
];
export const PRIORITIES_MAP = new Map<number, string>(
  PRIORITIES.map((item) => [item.value, item.label]) as any
);
